import {NgTemplateOutlet} from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, DestroyRef,
  EventEmitter,
  inject,
  Output, ViewChild
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import {map} from 'rxjs';
import { BrandingComponent } from '../branding/branding.component';
import {AuthStore} from "@features/auth/auth.store";
import {MatIcon} from "@angular/material/icon";
import {SvgIconTypeDirective} from "@shared/icons/svg-icon-type.directive";
import {BreakpointObserver} from "@angular/cdk/layout";
import {SMALL_WIDTH_BREAKPOINT} from "@shared/constant";
import {takeUntilDestroyed, toSignal} from "@angular/core/rxjs-interop";
import {MatMenuTrigger} from "@angular/material/menu";
import {ProfileMenuComponent} from "@shared/layout/components/profile-menu/profile-menu.component";
import {CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition} from "@angular/cdk/overlay";
import {UserSettingsStore} from '@features/user-settings';



@Component({
  selector: 'pd-header',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    BrandingComponent,
    MatSelectModule,
    NgTemplateOutlet,
    MatIcon,
    SvgIconTypeDirective,
    ProfileMenuComponent,
    CdkConnectedOverlay,
    CdkOverlayOrigin
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  protected authStore = inject(AuthStore);
  protected readonly userSettingsStore = inject(UserSettingsStore);
  protected  breakpoints = inject(BreakpointObserver);
  protected  destroyRef = inject(DestroyRef);
  protected cdr = inject(ChangeDetectorRef);
  @Output() menuOpened = new EventEmitter<void>();
  @Output() profileOpened = new EventEmitter<void>();
  @ViewChild(MatMenuTrigger) menuTrigger?: MatMenuTrigger;
  private closeTimeout?: ReturnType<typeof setTimeout>;

  profileOpen = false;
  private hoveringButton = false;
  private hoveringPanel = false;

  private hideTimeout?: ReturnType<typeof setTimeout>;

  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      offsetY: 8,
    },
  ];


  readonly isMobile = toSignal(
    this.breakpoints.observe(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`).pipe(
      map(result => result.matches),
      takeUntilDestroyed(this.destroyRef)
    ),
    { initialValue: false }
  );

  constructor() {
    this.userSettingsStore.ensureCurrencySettings();
  }

  setDefaultCurrency(defaultCurrencyId: number): void {
    this.userSettingsStore.setDefaultCurrency(defaultCurrencyId);
  }

  refresh(): void {
    this.userSettingsStore.refreshCurrencySettings();
  }

  onProfileClick(event: MouseEvent): void {
    if (this.isMobile()) {
      event.preventDefault();
      event.stopPropagation();
      this.profileOpened.emit();
    }
  }


  showProfile(): void {
    if (this.isMobile()) {
      return;
    }

    this.cancelHide();
    this.profileOpen = true;
  }


  cancelHide(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = undefined;
    }
    }


  leaveButton() {
    this.hoveringButton = false;
    this.hideIfNeeded();
  }

  enterPanel() {
    this.hoveringPanel = true;
    this.cancelHide();
  }

  leavePanel() {
    this.hoveringPanel = false;
    this.hideIfNeeded();
  }

  private hideIfNeeded() {
    this.cancelHide();

    this.hideTimeout = setTimeout(() => {
      if (!this.hoveringButton && !this.hoveringPanel) {
        this.profileOpen = false;
        this.cdr.detectChanges();
      }
    }, 150);
  }


}
